import { render, staticRenderFns } from "./shopMsg.vue?vue&type=template&id=1146ed7c&scoped=true"
import script from "./shopMsg.vue?vue&type=script&lang=js"
export * from "./shopMsg.vue?vue&type=script&lang=js"
import style0 from "./shopMsg.vue?vue&type=style&index=0&id=1146ed7c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1146ed7c",
  null
  
)

export default component.exports